import React from 'react'
import PropTypes from 'prop-types'

import Grid from '../Grid'

import Item from './Item'

const NumberWithIconGrid = (props) => {
  const { children } = props

  return (
    <Grid
      gridAutoRows="1fr"
      gridTemplateColumns="repeat(2, minmax(152px, 1fr))"
      gridTemplateRows="repeat(1, minmax(76px, 1fr))"
    >
      {children}
    </Grid>
  )
}

NumberWithIconGrid.propTypes = {
  children: PropTypes.node.isRequired,
}

NumberWithIconGrid.Item = Item

export default NumberWithIconGrid
